// Thin wrapper around Umami's global tracker.
//
// The Umami script is injected server-side by server.js (only when UMAMI_SRC +
// UMAMI_WEBSITE_ID are set). Pageviews — including SPA route changes — are
// tracked automatically by that script; this helper is only for custom events.
//
// It is a safe no-op when Umami isn't loaded (local dev, ad-blockers, or before
// the deferred script finishes loading), and never throws: analytics must not
// break the app.
export function trackEvent(name, data) {
    try {
        const umami = typeof window !== 'undefined' ? window.umami : undefined;
        if (!umami || typeof umami.track !== 'function') return;
        if (data && typeof data === 'object') {
            umami.track(name, data);
        } else {
            umami.track(name);
        }
    } catch (err) {
        // Swallow — tracking failures must never surface to the user.
    }
}
